// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ariaDelimiter":"ariaDelimiter_O0LFv","productTilesWrapper":"productTilesWrapper_LkXSW","fullWidthListItem":"fullWidthListItem_Q0NNi"};